import React, { useState, useMemo, forwardRef } from "react"
import { Search, ChevronRight } from '@mui/icons-material'
import Spinner from '../Spinner'
import { InputBase } from '@mui/material'
import { getFilterList } from '../../utils/tools'
import Tooltip from '../Tooltip'
import * as DropDown from "./Datasets.style"

const DatasetDropdown = forwardRef(({currentDataset, columns,close, changeColumn, changeDataset, handleOpenDiscovery, datasets }, ref) => {
    const [datasetInput , setDatasetInput] = useState('')
    const [columnInput , setColumnInput] = useState('')

    const handleChangeColumn = (e,dataset) => {
        changeColumn(e.currentTarget.attributes.value.value,e.currentTarget.attributes.name.value,dataset)
        close()
    }

    const handleChangeDataset = (e,item) => {
        const granularity = datasets.find(data => data.value === e.currentTarget.attributes.value.value)['graularity']
        changeDataset(e.currentTarget.attributes.value.value,e.currentTarget.attributes.name.value,item.althub_client_id,item.althub_dataset_id, granularity)
    }

    const allDatasetsColumns = useMemo(() => {
        return  datasets?.flatMap((dataset)=>{
            return dataset.columns.map((column)=>({dataset:dataset,...column}))
        }) 
        }, [datasets])

    const updateDatasetsInput = (e) => setDatasetInput(e.target.value)

    const updateColumnInput = (e) => setColumnInput(e.target.value)
    
    const clearColumnInput =()=> setColumnInput("")

    const datasetsOptions = useMemo(()=>{
        if(!datasets?.length){return <Spinner/>}
        const filterData = getFilterList(datasets, datasetInput, 'name')
        clearColumnInput()
        return filterData.map((item, index) => (
        <Tooltip key={`select-dataset-${item.value}-${index}`} title={item.name}>
            <DropDown.StylesListItem
            name={item.name}
            value={item.value}
            onClick={(e)=>handleChangeDataset(e,item)}
            button
            selected={currentDataset?.datasetValue === item.value} >
                <DropDown.Value>{item.name}</DropDown.Value>
                <ChevronRight/>
            </DropDown.StylesListItem>
        </Tooltip>))
    }, [datasetInput, datasets, currentDataset?.datasetValue]) // eslint-disable-line
    
    const columnsOptions = useMemo(()=>{
        if(!columns && !columnInput){return currentDataset?.datasetValue && <Spinner/>}
        const filterData = columnInput ? getFilterList(allDatasetsColumns, columnInput, 'name') : columns
        return filterData.map((item, index) => (
        <Tooltip key={`select-column-${item.value}-${index}`} title={item.description}>
        <DropDown.StylesListItem
            name={item.name}
            value={item.value}
            onClick={(e)=>{handleChangeColumn(e,item.dataset)}}
            button
            key={`select-column-${item.value}-${index}`}>
                <DropDown.Value>{item.name}</DropDown.Value> 
                <DropDown.OpenText>Open</DropDown.OpenText> 
            </DropDown.StylesListItem>
        </Tooltip>))
    }, [columnInput, columns, currentDataset?.datasetValue]) // eslint-disable-line
      
    return (
    <DropDown.DropDownContainer ref={ref} isOpen={handleOpenDiscovery}>
        <div className="dropdown">
            <div className="dropdownLeft">
                <DropDown.DropDownInputHeader>
                    <Search/>
                    <InputBase placeholder="Datasets" onChange={updateDatasetsInput}/>
                </DropDown.DropDownInputHeader>
                <div className="dropdownBody">
                    {datasetsOptions}
                </div>
            </div>
            <div className="dropdownRight">
                <DropDown.DropDownInputHeader>
                    <InputBase placeholder="KPIs" value={columnInput} onChange={updateColumnInput}/>
                </DropDown.DropDownInputHeader>
                <div className="dropdownBody">
                    {columnsOptions}
                </div>
            </div>
        </div>
        {handleOpenDiscovery && 
            <div className="dropdown-footer">
                <p onClick={handleOpenDiscovery}>Discovery Mode</p>
            </div>
        }
    </DropDown.DropDownContainer>
    )
})

export default DatasetDropdown